<template>
    <PageWrapper>
        <template #headline>
            <fa icon="fa-envelope" />
            {{ $t('emails') }}
        </template>

        <EmailsTable />
    </PageWrapper>
</template>

<script setup lang="ts">
import PageWrapper from '@src/partials/pages/PageWrapper.vue'
import EmailsTable from '@src/partials/emails/EmailsTable.vue'
</script>
